(function($) {
    'use strict';

    var recentItemsAddedFingerprint = '';
    var recentItemsAddedAt = 0;
    var DUPLICATE_WINDOW_MS = 2500;

    function isDebugEnabled() {
        try {
            return window.localStorage.getItem('amc_openai_pixel_debug') === '1';
        } catch (error) {
            return false;
        }
    }

    function debugLog(eventName, payload) {
        if (!isDebugEnabled()) {
            return;
        }

        console.log('[OpenAI Pixel]', eventName, payload);
    }

    if (typeof window.oaiq !== 'function' || typeof window.amcOpenaiPixel !== 'object') {
        return;
    }

    function measure(eventName, payload) {
        debugLog(eventName, payload);
        window.oaiq('measure', eventName, payload);
    }

    function normalizeItem(item, fallbackCurrency) {
        if (!item) {
            return null;
        }

        var quantity = parseInt(item.quantity, 10);
        var unitPrice = Number.parseFloat(item.price);
        var currency = item.currency || fallbackCurrency || window.amcOpenaiPixel.currency || 'BRL';

        if (!Number.isFinite(quantity) || quantity <= 0) {
            quantity = 1;
        }

        if (!Number.isFinite(unitPrice) || unitPrice <= 0) {
            return null;
        }

        return {
            content_type: 'product',
            id: String(item.sku || item.item_id || item.id || ''),
            name: String(item.item_name || item.name || '').trim(),
            quantity: quantity,
            amount: Math.round(unitPrice * 100),
            currency: currency
        };
    }

    function measureItemsAdded(payload) {
        if (!payload || !Array.isArray(payload.contents) || payload.contents.length === 0) {
            return;
        }

        var fingerprint = JSON.stringify(payload);
        var now = Date.now();

        if (recentItemsAddedFingerprint === fingerprint && (now - recentItemsAddedAt) < DUPLICATE_WINDOW_MS) {
            return;
        }

        recentItemsAddedFingerprint = fingerprint;
        recentItemsAddedAt = now;
        measure('items_added', payload);
    }

    function publishItemsAddedFromDataLayer(entry) {
        if (!entry || entry.event !== 'add_to_cart' || !entry.ecommerce) {
            return;
        }

        var ecommerce = entry.ecommerce;
        var items = Array.isArray(ecommerce.items) ? ecommerce.items : [];
        var currency = ecommerce.currency || window.amcOpenaiPixel.currency || 'BRL';
        var normalized = items
            .map(function(item) {
                return normalizeItem(item, currency);
            })
            .filter(Boolean);

        if (!normalized.length) {
            return;
        }

        var amount = normalized.reduce(function(total, item) {
            return total + (item.amount * item.quantity);
        }, 0);

        measureItemsAdded({
            type: 'contents',
            amount: amount,
            currency: currency,
            contents: normalized
        });
    }

    function wireDataLayerAddToCart() {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        var originalPush = dataLayer.push;

        dataLayer.forEach(function(entry) {
            publishItemsAddedFromDataLayer(entry);
        });

        dataLayer.push = function() {
            Array.prototype.forEach.call(arguments, function(entry) {
                publishItemsAddedFromDataLayer(entry);
            });

            return originalPush.apply(dataLayer, arguments);
        };
    }

    function amountFromText(value, currency) {
        var normalized = String(value || '').replace(/[^0-9,.-]/g, '');

        if (currency === 'BRL') {
            normalized = normalized.replace(/\./g, '').replace(',', '.');
        } else {
            normalized = normalized.replace(/,/g, '');
        }

        var amount = parseFloat(normalized);

        return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    }

    function itemFromButton(button) {
        var $button = $(button);
        var $product = $button.closest('.product, .product-type-simple, .product-type-variable');
        var productId = $button.data('product_id') || $button.attr('data-product_id') || '';
        var quantity = parseInt($button.closest('form').find('input.qty').val(), 10) || 1;
        var priceText = $product.find('.price').first().text();
        var name = $product.find('.woocommerce-loop-product__title, .product-title, .name').first().text().trim();
        var sku = $product.find('.sku').first().text().replace(/^SKU:\s*/i, '').trim();
        var currency = window.amcOpenaiPixel.currency || 'BRL';

        return {
            content_type: 'product',
            id: String(sku || productId),
            name: name,
            quantity: quantity,
            amount: amountFromText(priceText, currency),
            currency: currency
        };
    }

    measure('page_viewed', window.amcOpenaiPixel.pageView);

    if (window.amcOpenaiPixel.checkout) {
        measure('checkout_started', window.amcOpenaiPixel.checkout);
    }

    if (window.amcOpenaiPixel.order && window.amcOpenaiPixel.order.orderId) {
        var orderStorageKey = 'amc_openai_order_' + window.amcOpenaiPixel.order.orderId;
        var orderPayload = Object.assign({}, window.amcOpenaiPixel.order);

        // Keep orderId only for local deduplication; do not send non-standard fields.
        delete orderPayload.orderId;

        try {
            if (window.sessionStorage.getItem(orderStorageKey) !== '1') {
                measure('order_created', orderPayload);
                window.sessionStorage.setItem(orderStorageKey, '1');
            }
        } catch (error) {
            measure('order_created', orderPayload);
        }
    }

    wireDataLayerAddToCart();

    $(document.body).on('added_to_cart', function(event, fragments, cartHash, button) {
        var item = itemFromButton(button);

        if (!item.id) {
            return;
        }

        measureItemsAdded({
            type: 'contents',
            amount: item.amount * item.quantity,
            currency: item.currency,
            contents: [item]
        });
    });
}(jQuery));
